import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../lib/services';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { User } from '../../lib/classes/user';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  UploadImageModalComponent,
  UploadImageModel,
} from '../upload-image-modal/upload-image-modal.component';
import { ModalService } from '../../lib/services/modal.service';

@Component({
  selector: 'mj-unit-invitation',
  templateUrl: './unit-invitation.component.html',
  styleUrls: ['./unit-invitation.component.scss'],
})
export class UnitInvitationComponent implements OnInit {
  userForm: FormGroup;
  passwordForm: FormGroup;
  user: User;
  loading: boolean = true;
  unitName: string;
  step = 1;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private modalService: ModalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.validateUser();
  }

  setForm() {
    this.userForm = this.fb.group({
      name: [this.user.first_name, [Validators.required]],
      surname: [this.user.last_name, [Validators.required]],
      phone: this.user.user_profile.phone,
    });
    this.passwordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6)]],
        rep_password: ['', [Validators.required, Validators.minLength(6)]],
      },
      { validator: this.checkPasswords }
    );
  }

  checkPasswords(group: FormGroup) {
    const pass = group.controls.password.value;
    const confirmPass = group.controls.rep_password.value;
    return pass === confirmPass ? null : { notSame: true };
  }

  validateUser() {
    const token = this.route.snapshot.queryParamMap.get('token');
    const unitId = this.route.snapshot.params.id;

    this.userService
      .validateInvitation(unitId, { token })
      .pipe(take(1))
      .subscribe(res => {
        localStorage.setItem('id_token', res.token);
        this.userService
          .getCurrentUser()
          .pipe(take(1))
          .subscribe(user => {
            this.user = user;
            this.loading = false;
            this.setForm();
            this.unitName = localStorage.getItem('unit_name');
          });
      });
  }

  setPassword() {
    this.loading = true;
    const password = this.passwordForm.get('password').value;
    this.userService
      .updatePassword(password)
      .pipe(take(1))
      .subscribe(data => {
        this.step = 2;
        this.loading = false;
      });
  }

  updateProfile() {
    const updatedUser = this.user;
    updatedUser.first_name = this.userForm.get('name').value;
    updatedUser.last_name = this.userForm.get('surname').value;
    updatedUser.user_profile.phone = this.userForm.get('phone').value;
    this.userService
      .update(updatedUser)
      .pipe(take(1))
      .subscribe(
        data => {
          this.snackBar.open('Your account is saved, welcome in Mojob', null, {
            duration: 3000,
          });
          this.router.navigate(['login']);
        },
        () => {
          this.snackBar.open(
            'Something went wrong, please check all fields and try again',
            null,
            {
              duration: 3000,
            }
          );
        }
      );
  }

  handleAnimation(e) {
    const lottieAnimation = e;
    setTimeout(() => {
      lottieAnimation.playSegments([0, 39], true);
    }, 700);
  }

  updateImageAction($event: User) {
    this.user.user_profile.profile_picture_media_id =
      $event.user_profile.profile_picture_media_id;
    this.user.user_profile.profile_picture_thumbnail =
      $event.user_profile.profile_picture_thumbnail;
  }
}
